import messages from './messages.js';
import General from './General/index.jsx';
import Students from './Students/index.jsx';
import Period from './Period/index.jsx';
import Registration from './Registration/index.jsx';
import AssignAndVideo from './AssignAndVideo/index.jsx';

function getMeetingSteps(meetingSet) {
  const hasMeetings = meetingSet.meetings?.list?.length > 0;
  const hasBlocks = meetingSet.blocks && meetingSet.blocks.list.length > 0;
  return [
    { label: messages.general, component: General, header: messages.generalHeader },
    { label: messages.students, component: Students, header: messages.studentsHeader, disabled: () => !meetingSet.title },
    { label: messages.period, component: Period, disabled: () => !hasMeetings },
    { label: messages.assign, component: AssignAndVideo, disabled: () => !hasMeetings || !hasBlocks },
    { label: messages.registration, component: Registration, disabled: () => !hasMeetings || !hasBlocks },
  ];
}

export default getMeetingSteps;
